
<template>
  <div style="background-color: rgba(236, 243, 255, 1);">
    <HeadVue></HeadVue>
    <!-- Banner区域 -->
    <section class="banner" style="margin-top: 60px">

    </section>

    <section class="section">
      <div class="card-container">
        <div class="card-item">
          <div class="card-text">
            <h3>专注于垂直领域大语言模型技术创新的领军企业</h3>
            <p>明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域</p>
            <p>公司依托自主研发的明晟大语言模型，提供全方位、定制化的技术服务，包括训练数据标准化处理、模型私有化定制及一体化解决方案开发。从算力支撑到应用软件、硬件集成，明晟智能全方位赋能客户，精准满足其个性化需求。</p>
          </div>
          <div class="card-img">
            <img src="./assets/img/card-feature1.png" alt="智能工厂">
          </div>
        </div>
      </div>
    </section>

    <!-- 产品特点 -->
    <section class="features">
      <div class="container">
        <div class="feature-grid">
          <div class="feature-item">
            <h3>使命</h3>
            <p>用智能科技改变世界，让AI触手可及</p>
          </div>
          <div class="feature-item">
            <h3>愿景</h3>
            <p>成为全球领先的智能科技解决方案提供商</p>
          </div>
          <div class="feature-item">
            <h3>燎原精神</h3>
            <p>以星火燎原之势，不畏艰难，勇于创新，团结协作，将每一份努力汇聚成推动行业变革的强大力量</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 发展大事记 -->
    <section class="timeline">
      <div style="display: flex;justify-content: center;margin-bottom: 30px">
        <h2 class="section-title">明晟大事记</h2>
      </div>
      <div class="container" style="max-width: 100vw;padding: 0">
        <div class="box_22 flex-col">
          <div class="text-wrapper_36 flex-row" style="margin-left: 0;margin-right: 0;margin: auto">
            <span class="text_42">2021</span>
            <span class="text_43">2022</span>
            <span class="text_44" style="margin-left: 196px">2023</span>
            <span class="text_45">2024</span>
          </div>
<!--          <div class="box_27 flex-row">-->
<!--            <div class="group_10 flex-col"></div>-->
<!--          </div>-->
          <div class="box_28 flex-row justify-between" style="margin-left: 0;margin-right: 0;margin: auto;">

            <div class="group_11 flex-col" style="position: relative">
              <div class="block_8 flex-col" style="left: 0;top: -45px;right: 0;;margin: auto"></div>
              <div class="text-wrapper_12">
                <ul>
                  <li v-for="(item, index) in year2021Events" :key="index" class="text_46">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="group_12 flex-row" style="position: relative">
              <div class="block_8 flex-col" style="left: 0;top: -45px;right: 0;margin: auto"></div>
              <div class="text-group_10 flex-col justify-between">
                <div class="text-wrapper_16">
                  <ul>
                    <li v-for="(item, index) in year2022Events" :key="index" class="text_54">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="group_13 flex-col" style="position: relative">
              <div class="block_8 flex-col" style="left: 0;top: -45px;right: 0;margin: auto"></div>
              <div class="text-wrapper_19">
                <ul>
                  <li v-for="(item, index) in year2023Events" :key="index" class="text_60">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="group_14 flex-col" style="position: relative">
              <div class="block_8 flex-col" style="left: 0;top: -45px;right: 0;margin: auto"></div>
              <div class="text-wrapper_23">
                <ul>
                  <li v-for="(item, index) in year2024Events" :key="index" class="text_68">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="block_7 flex-col" style="left: 0;right: 0;margin: auto"></div>
<!--          <div class="block_8 flex-col" style="left: 457px;"></div>-->
<!--          <div class="block_9 flex-col" style="left: 784px"></div>-->
<!--          <div class="block_9 flex-col" style="left: 1094px"></div>-->
<!--          <div class="block_10 flex-col" style="left: 1421px"></div>-->
        </div>
      </div>
    </section>

    <!-- 企业荣誉 -->
    <section class="section">
      <div style="display: flex;justify-content: center;margin-bottom: 30px">
        <h2 class="section-title">企业荣誉</h2>
      </div>
      <div class="card-container">
        <div class="card-item">
          <div class="card-text">
            <h3>科技创新成果丰硕</h3>
            <p>已申请专利100+项，其中发明专利占比60%以上拥有计算机软件著作权80+项</p>
            <p>已建设1个省级科技创新平台主持5项人工智能产业团体标准制定工作</p>
          </div>
          <div class="card-img">
            <img src="./assets/img/rongyu.png" alt="智能工厂">
          </div>
        </div>
      </div>
    </section>

    <!-- 战略布局 -->
    <section class="strategy">
      <div style="display: flex;justify-content: center;margin-bottom: 30px">
        <h2 class="section-title">战略布局</h2>
      </div>
      <div class="container">
        <div class="box_25 flex-row" style="margin: 0">
          <div class="text-wrapper_27 flex-col">
            <span class="text_1">[&nbsp;长三角区域业务运营中心&nbsp;]</span>
            <span class="text_2">[&nbsp;2024年&nbsp;&nbsp;明晟落户中新苏滁高新区&nbsp;]</span>
            <span class="text_3">[&nbsp;数据标注与处理中心&nbsp;]</span>
            <span class="text_4">[&nbsp;大湾区区域业务运营中心&nbsp;]</span>
            <span class="text_5">[&nbsp;海外业务运营中心&nbsp;]</span>
          </div>
          <div class="group_1 flex-col">
            <div class="section_10 flex-row">
              <div class="section_2 flex-col"></div>
              <div class="section_3 flex-col"></div>
              <div class="section_4 flex-col"></div>
              <div class="section_5 flex-col"></div>
            </div>
            <div class="section_11 flex-row justify-between">
              <div class="group_15 flex-col justify-between">
                <!--                  <img class="image_3" referrerpolicy="no-referrer"-->
                <!--                    src="./assets/img/MasterDDSSlicePNG78bc1e2eb88227bf5d3d5688b32d402c.png" />-->
                <div class="group_4 flex-col"></div>
              </div>
              <div class="group_16 flex-col justify-between">
                <span class="text_6">江苏泗阳</span>
                <div class="box_6 flex-col"></div>
                <span class="text_7">安徽滁州总部</span>
              </div>
            </div>
            <div class="section_12 flex-row justify-between">
              <div class="section_6 flex-col"></div>
              <span class="text_8">重庆云阳</span>
            </div>
            <div class="section_13 flex-row justify-between">
              <div class="box_7 flex-col"></div>
              <span class="text_9">澳门</span>
            </div>
            <div class="section_14 flex-row justify-between">
              <div class="group_8 flex-col"></div>
              <span class="text_10">新加坡</span>
            </div>
            <div class="group_9 flex-col"></div>
            <img class="image_4" referrerpolicy="no-referrer"
                 src="./assets/img/logo.png" />
          </div>
        </div>
      </div>
    </section>

    <FooterVue style="margin-top: 0"></FooterVue>

  </div>

</template>

<script>
import FooterVue from "@/views/common/FooterVue.vue";
import HeadVue from "@/views/common/HeadVue.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  components: { FooterVue, HeadVue },
  metaInfo: {
    title: '滁州人工智能-明晟智能科技有限公司',
    meta: [
      { name: 'description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:type', content: 'webpage' },
      { property: 'og:title', content: '滁州人工智能-明晟智能科技有限公司' },
      { property: 'og:description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:url', content: 'https://minsun-ai.com/' },
      { name: 'Keywords',content: "明晟智能科技有限公司,明晟,明晟智能,滁州人工智能,人工智能,AI,明晟大模型,明晟工业大模型"}
    ]
  },
  data(){
    return {
      year2021Events: [
        '恒智日晟在武汉学院腾讯众创空间515办公室创立',
        '区块链农产溯源平台上线',
        '区块链数据确权平台上线',
        '大数据舆情分析平台上线'
      ],
      year2022Events: [
        '湖北省明呈创新科技研发中心成立',
        '自然语言处理算法研究',
        '研发基于堆叠BI-LSTM网络和协同注意力算法'
      ],
      year2023Events: [
        '重庆云阳数据处理与标注中心成立',
        '获批国家高新技术企业、国家创新型中小科技型企业',
        '荣获「湖北省首批数字经济应用场景」',
        '明晟大模型21B上线'
      ],
      year2024Events: [
        '明晟智能总部落户中新苏滁高新区',
        '苏滁明晟人工智能众创空间成立',
        '湖北大学人工智能学院硕士生联培基地成立',
        '武汉学院产学研合作基地成立'
      ],
    }
  }
}
</script>
<style scoped lang="css" src="@/views/minsun_guanyuwomen/assets/index.css" />
<style scoped lang="css">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}
.banner {
  height: 500px;
  //width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100% ;
  //text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image:  url("./assets/img/banner.png");
}
.section-title {
  font-size: 32px;
  color: #181F5C;
  margin-bottom: 20px;
  position: relative;
  text-align: center;
  font-family: "Alimama ShuHeiTi-Bold";
}
.section-title:before{
  left: -135px !important;
}
.section-title:after{
  right: -135px !important;
}
.section-title:before {
  content: "";
  background-image: url('assets/img/title-icon-left.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;

  //transform: translateX(-50%);
}
.section-title:after {
  content: "";
  background-image: url('assets/img/title-icon-right.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;
  right: 185px;
  //transform: translateX(-50%);
}
.feature-section {
  background-color: #fff;
  padding: 40px 0;
}

.card-container {
  max-width: 1200px;
  margin: 0 auto;
}

.card-item {
  display: flex;
  margin-bottom: 40px;
  align-items: center;
}

.card-item:nth-child(even) {
  flex-direction: row-reverse;
}

.card-img {
  flex: 1;
  padding: 20px;
}

.card-img img {
  width: 100%;
  //border-radius: 10px;
  //box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.card-text {
  flex: 1;
  padding: 20px;
  text-align: left;
}

.card-text h3 {
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  font-family: "Alimama ShuHeiTi-Bold";
}

.card-text p {
  width: 560px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 顶部导航 */
.header {
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 100;
}

.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

.nav ul {
  display: flex;
  list-style: none;
}

.nav li {
  margin-left: 30px;
}

.nav a {
  text-decoration: none;
  color: #333;
  font-size: 16px;
}

.nav a:hover {
  color: #0066cc;
}

/* 产品特点 */
.features {
  padding: 10px 0;
  //background: #f8f9fa;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
}

.feature-item {
  height: 334px;
  //width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100% ;
  //text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
}
.feature-item h3{
  font-weight: 700;
  font-size: 28px;
  color: #FFFFFF;
  font-family: "Alimama ShuHeiTi-Bold";
  margin-bottom: 20px;
}
.feature-item p{
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;

}
.feature-item:nth-child(1) {
  background-image:  url("./assets/img/about-features3.png");
}
.feature-item:nth-child(2) {
  background-image:  url("./assets/img/about-features2.png");
}
.feature-item:nth-child(3) {
  background-image:  url("./assets/img/about-features1.png");
}
.feature-img img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
}

/* 发展大事记 */
.timeline {
  padding: 60px 0;
}

.timeline h2 {
  text-align: center;
  margin-bottom: 40px;
}

.timeline-wrapper {
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 20px 0;
}

.timeline-wrapper::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background: #0066cc;
}

.timeline-item {
  position: relative;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1;
}

.year {
  font-size: 24px;
  font-weight: bold;
  color: #0066cc;
  margin-bottom: 10px;
}

.events {
  list-style: none;
}

.events li {
  margin-bottom: 8px;
  font-size: 14px;
}

/* 企业荣誉 */
.honor {
  padding: 60px 0;
  background: #f8f9fa;
}

.honor-content {
  display: flex;
  align-items: center;
  gap: 30px;
}

.honor-text {
  flex: 1;
}

.honor-img {
  flex: 1;
}

.honor-img img {
  width: 100%;
  border-radius: 8px;
}

/* 战略布局 */
.strategy {
  padding: 20px 0 200px 0;
}

.map-container {
  position: relative;
  margin-top: 40px;
}

.china-map {
  position: relative;
}

.china-map img {
  width: 100%;
}

.location-points .point {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #0066cc;
  border-radius: 50%;
  cursor: pointer;
}

.location-points .point::before {
  content: attr(data-name);
  position: absolute;
  white-space: nowrap;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
}

/* 页脚 */
.footer {
  background: #0066cc;
  color: #fff;
  padding: 40px 0;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.qr-codes {
  display: flex;
  gap: 20px;
}

.qr-code {
  text-align: center;
}

.qr-code img {
  width: 120px;
  height: 120px;
  background: #fff;
  padding: 10px;
  border-radius: 4px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .feature-grid {
    grid-template-columns: 1fr;
  }

  .timeline-wrapper {
    flex-direction: column;
    gap: 20px;
  }

  .timeline-wrapper::before {
    display: none;
  }

  .honor-content {
    flex-direction: column;
  }

  .footer-content {
    flex-direction: column;
    gap: 30px;
  }
}
</style>